import styles from 'styles/views/widgets/Popup.css';
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Draggable from 'react-draggable';
import config from 'config/config_server.json';
import {HEADER_HEIGHT} from 'main';
import { isFixed } from 'utils/css';
import classnames from 'classnames';

export default class Popup extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    onClose: PropTypes.func,
    onOK: PropTypes.func,
    targetElement: PropTypes.object,
    targetElementRect: PropTypes.object,
    visible: PropTypes.bool,
    mobileVersion: PropTypes.bool
  };

  componentDidMount () {
    this._setInitialPosition();
  };

  componentDidUpdate (prevProps) {
    if (prevProps.targetElement !== this.props.targetElement) {
      this._setInitialPosition();
    }
  };

  // handleDrag = (containerClassNames) => (e, ui) => {
  //   let modalEl = document.getElementsByClassName(containerClassNames)[0]
  //   if (!isInViewPort(modalEl)) {
  //     ui.position = {left: 0, top: 0}
  //     console.log(ui)
  //     console.log('outside')
  //     modalEl.style.transform = ''
  //     console.log(modalEl.style.transform)
  //   }
  // }

  render () {
    let grippyUrl = `${config.editorUrl}/grippy.png`;
    let closeUrl = `${config.editorUrl}/close.png`;
    let dragClassNames = `${styles.header} ${styles.grippy}`;
    let selectorToMatch = `.${styles.grippy}`;
    let containerStyle = {
      display: this.props.visible !== false ? '' : 'none'
    };
    if (isFixed(this.props.targetElement)) {
      containerStyle.position = 'fixed !important';
    }
    return (
      <Draggable
        handle={selectorToMatch}
      >
        <div
          ref='aurycPopup'
          className={classnames(
            styles.container,
            this.props.className || '',
            {[styles.mobileView]: this.props.mobileVersion}
          )}
          style={containerStyle}>
          <div className={dragClassNames}>
            <img className={styles.grippy}
              src={grippyUrl}
              width='12'
              height='12'
              draggable='false'
              style={{height: '12px !important', width: '12px !important'}}/>
            <a className={styles.close} onClick={this.props.onClose}>
              <img src={closeUrl}
                width='12'
                height='12'
                style={{height: '12px !important', width: '12px !important'}}/>
            </a>
          </div>
          <div className={styles.body}>
            {this.props.children}
          </div>
        </div>
      </Draggable>
    );
  };

  _setInitialPosition () {
    let { targetElement, targetElementRect } = this.props;
    let modalEl = ReactDOM.findDOMNode(this.refs['aurycPopup']);
    const modalWidth = modalEl.offsetWidth;
    const modalHeight = modalEl.offsetHeight;

    let clearance = {
      bottom: 40,
      left: 40,
      right: 40,
      top: HEADER_HEIGHT
    };
    if (targetElement) {
      this._setPositionToElement(modalEl, modalHeight, modalWidth,
        targetElement, false, clearance, 20, targetElementRect);
    } else {
      this._setPositionToCenter(modalEl, modalHeight, modalWidth);
    }

    modalEl.style.visibility = 'visible';
  };

  _setPositionToElement (modalEl, modalHeight, modalWidth, targetEl, relativeToViewport,
    clearance = {}, padding = 0, targetElementRect) {
    if (!isInViewPort(targetEl)) {
      this._setPositionToCenter(modalEl, modalHeight, modalWidth);
      return;
    }

    let offsetX = relativeToViewport ? 0 : (window.scrollX || window.pageXOffset);
    let offsetY = relativeToViewport ? 0 : (window.scrollY || window.pageYOffset);
    let width = window.innerWidth;
    let height = window.innerHeight;
    let x;  // left
    let y;  // top

    clearance = {bottom: 0, top: 0, right: 0, left: 0, ...clearance};
    padding = padding || 0;
    let bounds = targetEl.getBoundingClientRect();
    if (bounds.right === bounds.left && bounds.top === bounds.bottom && targetElementRect) {
      bounds = this.props.targetElementRect;
    }
    let space = {
      'bottom': window.innerHeight - bounds.bottom - modalHeight - (clearance.bottom || 0),
      'top': bounds.top - modalHeight - (clearance.top || 0),
      'right': window.innerWidth - bounds.right - modalWidth - (clearance.right || 0),
      'left': bounds.left - modalWidth - (clearance.left || 0)
    };
    if (space.bottom < 0 && space.top < 0 && space.right < 0 && space.left < 0) {
      // no room for the modal, show it in the middle
      this._setPositionToCenter(modalEl, modalHeight, modalWidth);
      return;
    } else if (space.bottom >= 0 || space.top >= 0) {
      // calculate y coorodiate
      if (space.bottom >= 0) {
        y = offsetY + bounds.bottom + padding;
      } else {
        y = offsetY + bounds.top - modalHeight - padding;
      }
      // calculate x coorodiate
      x = bounds.left;
      if (x < clearance.left) {
        x = clearance.left;
      }
      if (x + modalWidth + clearance.right > width) {
        x = width - modalWidth - clearance.right;
      }
      x += offsetX;
    } else if (space.right >= 0 || space.left >= 0) {
      // calculate x coorodiate
      if (space.right >= 0) {
        x = offsetX + bounds.right + padding;
      } else {
        x = offsetX + bounds.left - modalWidth - padding;
      }
      // calculate y coorodiate
      y = bounds.top;
      if (y < clearance.top) {
        y = clearance.top;
      }
      if (y + modalHeight + clearance.bottom > height) {
        y = height - modalHeight - clearance.bottom;
      }
      y += offsetY;
    }
    modalEl.style.transform = '';
    modalEl.style.left = (x > 0 ? x : 0) + 'px';
    modalEl.style.top = (y > 0 ? y : targetElementRect.top) + 'px';
  }

  _setPositionToCenter (modalEl, modalHeight, modalWidth, relativeToViewport) {
    let offsetX = relativeToViewport ? 0 : (window.scrollX || window.pageXOffset);
    let offsetY = relativeToViewport ? 0 : (window.scrollY || window.pageYOffset);

    var windowWidth = window.innerWidth || screen.width || document.documentElement.clientWidth;
    var windowHeight = window.innerHeight || screen.height || document.documentElement.clientHeight;
    const x = (windowWidth / 2) - (modalWidth / 2) + offsetX;
    const y = (windowHeight / 2) - (modalHeight / 2) + offsetY;
    modalEl.style.left = x + 'px';
    modalEl.style.top = (32 + y) + 'px';
  }
}

function isInViewPort (element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/widgets/Popup.js
 **/